import React from 'react'
import c from 'classnames'

import Collection from 'components/widgets/Collection'
import * as F from 'discada/dist/Form'
import { initialDiscount } from 'reducers/quoteReducers'

export function Discount({ item, editValue, index }) {
  return (
    <div className="quote-config-collection-leaseTerm">
      <F.TextField
        size="small"
        value={item.name}
        onChange={({ target }) => editValue(index, 'name', target.value)}
      />
      <F.TextField
        size="small"
        type="number"
        value={item.amount}
        onChange={({ target }) =>
          editValue(index, 'amount', parseFloat(target.value))
        }
      />
      <F.CheckboxField
        size="small"
        checked={item.include || false}
        onChange={e => editValue(index, 'include', e.target.checked)}
      />
    </div>
  )
}

export default function Discounts({
  items,
  addItem,
  removeItem,
  editValue,
  hideHelp,
  hideRemove,
}) {
  let s = 'discounts'

  return (
    <section className="quote-fees">
      <h3>Special Discounts</h3>
      {!hideHelp && (
        <article className="message is-info is-small">
          <div className="message-body">Lorem ipsum...</div>
        </article>
      )}
      <Collection
        key={s}
        hideRemove={hideRemove}
        addButtonLabel="Add Special Discount"
        headers={['Name', 'Amount', 'Include']}
        className={c('quote-config-collection', `quote-config-collection-${s}`)}
        items={items}
        addItem={addItem(s, { ...initialDiscount })}
        removeItem={removeItem(s)}
        itemRenderer={(item, index, items) => (
          <Discount {...{ item, index, items }} editValue={editValue(s)} />
        )}
      />
    </section>
  )
}
